import 'core-js';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import segments from './data.json'
import debounce from 'debounce';

export const SegmentContext = React.createContext()

const segmentRoutes = segments.map(({ id, name }) => {
  return {
    id,
    hash: '#' + name.toLowerCase().split(' ').join('-')
  }
})

const hash = window.location.hash
const initialSegment = hash && (segmentRoutes.find(item => item.hash === hash) || {}).id

const Provider = ({ children }) => {

  const [selectedSegmentId, setSelectedSegmentId] = useState(initialSegment || null)
  const [selectedSolutionId, setSelectedSolutionId] = useState(null)

  const segment = selectedSegmentId ? segments.find(item => item.id === selectedSegmentId) : null
  const solution = segment && selectedSolutionId ? segment.solutions.find(item => item.id === selectedSolutionId) : null
  const selectSolutionWithDelay = debounce(setSelectedSolutionId, 1000);

  return (
    <SegmentContext.Provider value={{ segments, segment, solution, selectSegment: setSelectedSegmentId, selectSolution: setSelectedSolutionId, selectSolutionWithDelay }} >
      { children }
    </SegmentContext.Provider>
  )
}

ReactDOM.render((
  <Provider>
    <App />
  </Provider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
